var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667352;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.36,56.82c0,2.89-2.34,5.23-5.23,5.23s-5.23-2.34-5.23-5.23,2.34-5.23,5.23-5.23,5.23,2.34,5.23,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.09,56.82c0,2.89-2.34,5.23-5.23,5.23s-5.23-2.34-5.23-5.23,2.34-5.23,5.23-5.23,5.23,2.34,5.23,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.32,73.77c0,2.89-2.34,5.23-5.23,5.23s-5.23-2.34-5.23-5.23,2.34-5.23,5.23-5.23,5.23,2.34,5.23,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.85,49.43s-6.31,11.18-17.49,11.18-17.85-11.18-17.85-11.18l-4.69,3.43,1.98,2.52,2.7-1.8s4.51,9.17,16.41,9.87v3.29h2.7v-3.28c12.07-.59,17.13-9.52,17.13-9.52l1.62,1.08,1.98-2.52-4.51-3.06Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.14,29.14c0,4.49-3.64,8.14-8.14,8.14s-8.14-3.64-8.14-8.14,3.64-8.14,8.14-8.14,8.14,3.64,8.14,8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35,57.87c5.37,0,10.2-2.32,13.55-6v-6.19c0-2.94-2.4-5.34-5.34-5.34h-16.41c-2.94,0-5.34,2.4-5.34,5.34v6.19c3.35,3.69,8.18,6,13.55,6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen04);
export default __webpack_public_path__ + "static/media/green04.67b56754b1a179450f5a465051383a95.svg";
export { ForwardRef as ReactComponent };